// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bWf4","toggle":"styles_toggle__NdpFI","preview":"styles_preview__1k6BH"};